function n(e,...t){let r=e;return t.forEach((c,f)=>{r=r.replace(`{${f}}`,`${c}`)}),r}export{n as msgf};
